import EmblaCarousel from 'embla-carousel';

class ImageGallery extends HTMLElement {
  constructor() {
    super();
    this.embla = null;
    this.carousel = null;
  }

  setupCarousel() {
    this.embla = EmblaCarousel(this.carousel, {
      loop: true,
    });
    this.syncSlideVideos(this.embla.selectedScrollSnap());

    if (this.paginationButtons?.length) {
      this.paginationButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.embla.scrollTo(parseInt(button.dataset.paginationButton, 10));
        });
      });
    }

    if (this.navigationButtons?.length) {
      this.navigationButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.dataset.navigationButton === 'previous') {
            this.embla.scrollPrev();
          } else {
            this.embla.scrollNext();
          }
        });
      });
    }

    this.embla.on('select', () => {
      const selectedIndex = this.embla.selectedScrollSnap();
      this.paginationButtons.forEach((button) => {
        button.dataset.active = button.dataset.paginationButton === selectedIndex.toString();
      });
      this.syncSlideVideos(selectedIndex);
    });
  }

  syncSlideVideos(selectedIndex) {
    this.embla.slideNodes().forEach((slide, index) => {
      slide.querySelectorAll('video').forEach((video) => {
        if (index === selectedIndex) {
          if (video.autoplay && video.muted) {
            video.play().catch(() => {});
          }
        } else {
          video.pause();
        }
      });
    });
  }

  destroyCarousel() {
    this.embla?.destroy();
    this.paginationButtons?.forEach((button) => {
      button.removeEventListener('click', () => {
        this.embla.scrollTo(parseInt(button.dataset.paginationButton, 10));
      });
    });
    this.navigationButtons?.forEach((button) => {
      button.removeEventListener('click', () => {
        this.embla.scrollPrev();
      });
    });
  }

  connectedCallback() {
    this.carousel = this.querySelector('[data-carousel]');
    this.images = this.querySelectorAll('img');
    this.paginationButtons = Array.from(this.querySelectorAll('[data-pagination-button]'));
    this.navigationButtons = Array.from(this.querySelectorAll('[data-navigation-button]'));

    if (this.carousel) {
      this.setupCarousel();
    }
  }

  disconnectedCallback() {
    this.destroyCarousel();
  }
}

if (!customElements.get('image-gallery')) {
  customElements.define('image-gallery', ImageGallery);
}